<template>
  <div id="page-wrap">
    <div class="container-fluid">
      <div class="container">
        <div class="content-wrap">
          <div class="header">
            <h1>睿客网用户协议</h1>
          </div>
          <div class="content">
            <h2>一、服务内容及使用须知</h2>
            <ul>
              <li>睿客网是一个面向广大用户提供数据存储、同步、管理和分享等和应用的在线服务。睿客网是信息存储空间平台，其本身不直接上传、提供内容，对用户传输内容不做任何修改或编辑。</li>
              <li>用户理解，睿客网服务仅提供相关的网络服务，除此之外与相关网络服务有关的设备（如个人电脑、手机、及其他与接入互联网或移动网有关的装置）及所需的费用（如为接入互联网而支付的电话费及上网费、为使用移动网而支付的手机费）均应由用户自行负担。</li>
              <li>用户不得滥用睿客网的服务，睿客网服务帐号仅限用户个人使用，帐号不得有偿或无偿提供给任何第三方使用。睿客网在此郑重提请您注意，任何经由本服务以上传、张贴、发送即时信息、电子邮件或任何其他方式传送的资讯、资料、文字、软件、音乐、音讯、照片、图形、视讯、信息、用户的登记资料或其他资料（以下简称“内容”），无论是公开还是私下传送，均由内容提供者、使用者对其上传、使用行为自行承担责任。睿客网服务作为信息存储空间服务平台，无法控制经由本服务传送之内容，也无法对用户的使用行为进行全面控制，因此不能保证内容的合法性、正确性、完整性、真实性或品质；用户已预知使用本服务时，可能会接触到令人不快、不适当等内容，并同意将自行加以判断并承担所有风险，而不依赖于睿客网服务。</li>
              <li>若用户使用睿客网服务的行为不符合本协议，在经由通知、举报等途径发现时有权做出独立判断，且有权在无需事先通知用户的情况下立即终止向用户提供部分或全部服务。用户若通过睿客网服务散布和传播反动、色情或其他违反国家法律、法规的信息，睿客网服务的系统记录有可能作为用户违反法律法规的证据；因用户进行上述内容在睿客网服务的上载、传播而导致任何第三方提出索赔要求或衍生的任何损害或损失，由用户自行承担全部责任。</li>
              <li>根据用户使用睿客网的情况，睿客网将不断改善产品体验，例如提供个性化的服务或提高用户使用服务的安全性。同时，如经由通知、举报等 途径发现用户在使用睿客网服务所提供的网络服务时违反任何本协议的规定，睿客网有权要求用户改正或直接采取一切睿客网认为必要的措施（包括但不限于更改或删除用户上载的内容、暂停或终止用户使用网络服务，和/或公示违法或违反本协议约定使用睿客网服务用户账户的权利）以减轻用户不当行为造成的影响。</li>
            </ul>
            <h2>二、用户发送、传播的内容与第三方投诉处理</h2>
            <ul>
              <li>您通过本服务发送或传播的内容（包括但不限于网页、文字、图片、音频、视频、图表等）均由您自行承担责任。</li>
              <li>您发送或传播的内容应有合法来源，相关内容为您所有或您已获得权利人的授权。</li>
              <li>您同意睿客网可为履行本协议或提供本服务的目的而使用您发送或传播的内容。</li>
              <li>如果睿客网收到权利人通知，主张您发送或传播的内容侵犯其相关权利的，您同意睿客网有权进行独立判断并采取删除、屏蔽或断开链接等措施。</li>
              <li>您使用本服务时不得违反国家法律法规、侵害他人合法权益。您理解并同意，如您被他人投诉侵权或您投诉他人侵权，睿客网有权将争议中相关方的主体、联系方式、投诉相关内容等必要信息提供给其他争议方或相关部门，以便及时解决投诉纠纷，保护他人合法权益。</li>
            </ul>
            <h2>三、群应用使用协议</h2>
            <ul>
              <li>群主、群管理员仅有依约使用群、管理群的权利。群主除可以按照睿客网的规则以无偿方式，将自己的群主身份及群主相应对群的管理权限转移给其他群成员之外，群主不得有偿或无偿以借用、租用、转让或售卖等任何方式将自己的群主身份及群主相应对群的管理权限转移给其他群成员或其他任何人，否则，睿客网有权采取收回群，中止或终止对群的使用、管理及相关服务等措施。</li>
              <li>群成员仅有依约使用群的权利。</li>
              <li>除上述明确的群主、群管理员和群成员享有的权利之外，群的所有权及其他全部权利归睿客网所有。同时，群主、群管理员和群成员享有的对群的相应权利，除睿客网明确允许外，均不得有偿或无偿以借用、租用、转让或售卖等任何方式转移给他人。</li>
              <li>睿客网不对您在本服务中相关数据的删除或储存失败负责。</li>
              <li>睿客网有权根据实际情况自行决定在服务器上对您在本服务中的数据的最长储存期限、为单个用户分配的最大存储使用空间等。您可根据自己的需要自行备份本服务中的相关数据。</li>
              <li>
                您在使用本服务时不得利用本服务从事以下行为，包括但不限于：
                <ol>
                  <li>发布、传送、传播、储存违反国家法律、危害国家安全统一、社会稳定、公序良俗、社会公德以及侮辱、诽谤、淫秽、暴力的内容；</li>
                  <li>发布、传送、传播、储存侵害他人名誉权、肖像权、知识产权、商业秘密等合法权利的内容；</li>
                  <li>虚构事实、隐瞒真相以误导、欺骗他人；</li>
                  <li>发表、传送、传播广告信息及垃圾信息；</li>
                </ol>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Content",
  created() {
    this.$store.commit("SET_THEME", "用户协议");
  }
};
</script>

<style scoped>
</style>